import ListItem from '@ahamove/web-components/lib/ListItem';
import ListItemAvatar from '@ahamove/web-components/lib/ListItemAvatar';
import ListItemButton from '@ahamove/web-components/lib/ListItemButton';
import ListItemText from '@ahamove/web-components/lib/ListItemText';
import Skeleton from '@ahamove/web-components/lib/Skeleton';
import Stack from '@ahamove/web-components/lib/Stack';
import cn from 'classnames';
import useIsMobile from '@/shared-hooks/useIsMobile';

export default function EVItemLoading() {
  const isMobile = useIsMobile();

  return (
    <ListItem
      sx={{
        minHeight: 192,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'grey.100',
        boxShadow: '0px 10px 24px -5px rgba(15, 15, 15, 0.02)',
        borderRadius: 6,
        overflow: 'hidden',
        alignItems: 'flex-start',
      }}
    >
      <ListItemButton
        data-test-id="evItemLoading"
        role="button"
        disableRipple
        disabled
        className={cn({ 'space-y-2': isMobile })}
        sx={(theme) => ({
          pt: isMobile ? 3 : 1,
          pr: `${theme.spacing(9)} !important`,
          pb: isMobile ? 3 : 1,
          pl: isMobile ? 3 : 2,
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
        })}
      >
        <ListItemAvatar>
          <Skeleton
            variant="rounded"
            height={isMobile ? 94 : 172}
            width={isMobile ? 128 : 256}
            sx={{
              mr: 3,
              borderTopLeftRadius: isMobile ? 4 : 16,
              borderBottomLeftRadius: isMobile ? 4 : 16,
            }}
          />
        </ListItemAvatar>
        <ListItemText
          primary={
            <Stack alignItems="flex-start" spacing={isMobile ? 1 : 2}>
              <Skeleton
                variant="rounded"
                height={isMobile ? 24 : 32}
                width={isMobile ? 190 : 245}
              />
              <Skeleton
                variant="rounded"
                height={isMobile ? 16 : 24}
                width={isMobile ? 130 : 160}
              />
            </Stack>
          }
        />
      </ListItemButton>
    </ListItem>
  );
}
